module.exports = __webpack_public_path__ + "img/lembar-tagihan-active.250f4e40.svg";